import {ORIGIN} from "@/store/leads/mutation-types";

export default {
  methods: {
    getLeadLabel: function(lead) {
      const type = lead.availability_guarantee === 0 ? 'Marketplace' : 'Offered';
      const origin = this.origin ? this.origin : '-';
      return origin + ' ' + type;
    },
    fireEvent: function(lead = null, type = null, category = null, action = null) {
      this.$ga.event({
        eventCategory: category ?? "leads",
        eventAction: action ?? "click",
        eventLabel: (lead && type) ? (type + " " + this.getLeadLabel(lead)) : type,
      });
      this.removeOrigin();
    },
    removeOrigin: function() {
      this.origin = null;
    },
  },
  computed: {
    origin: {
      get: function() {
        return this.$store.state.ORIGIN;
      },
      set: function (value) {
        this.$store.commit(ORIGIN, value);
      }
    }
  }
};
